import { Box } from "@mui/system";
import { styled } from "@mui/material/styles";

const Overlay = styled(Box, {
  shouldForwardProp: (prop) => prop !== "visible", // this prevents 'visible' from being passed to DOM
})(({ visible, sx, theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.2)",
  backdropFilter: "blur(5px)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 29,
  opacity: visible ? 1 : 0,
  visibility: visible ? "visible" : "hidden",
  transition: "opacity 0.3s ease, visibility 0.3s ease",
  ...sx,
}));

export default Overlay;
